module.exports = __webpack_public_path__ + "static/media/bytt-nn-21.50ab6495.mp3";